
import { Outlet } from "react-router-dom";

export const ROUTES = {
  HOME: "/",

  SUPPORT: "/support",
};



const App = () => {

  return (
    <>
    <Outlet />
    </>
  );
};

export default App;
